import * as React from 'react';
import { connect } from 'react-redux';
import UserListHeader from '../../components/users/UserListHeader';
import Loader from '~/common/components/Loader';
import { navigate } from '~/router';
import { createRouteNodeSelector } from 'redux-router5';
import { getUserOrgFilter, userOrgFilter } from '~/apps/shared/services/qsfilter';
import { setUserCurrentPage } from '~/apps/shared/actions/users';

class OrgUserHeader extends React.Component<any, any> {

  onCreate = () => {
    this.props.onCreate();
  };

  render() {
    const { orgId, organizations, route: { params }, dispatch } = this.props;
    const org = organizations.entities[orgId];
    const filter = getUserOrgFilter(params);
    let title = 'Users';

    if (org) {
      title = `${org.name} - Users`;
    }

    if (organizations.ui.loading) {
      return (
        <Loader />
      );
    }

    return (
      <UserListHeader
        onFilter={(q) => {
          filter.q = q;
          navigate('pos.admin.settings.team', userOrgFilter(filter));
          dispatch(setUserCurrentPage(0));
        }}
        filter={filter}
        title={title}
        onCreate={this.onCreate}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin.settings.team');

  return {
    organizations: state.shared.organizations,
    ...selector(state),
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgUserHeader);
